"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var assert_1 = __importDefault(require("assert"));
var ginkgoch_buffer_io_1 = require("ginkgoch-buffer-io");
var Point_1 = __importDefault(require("../geom/Point"));
var Constants_1 = __importDefault(require("./Constants"));
var Polygon_1 = __importDefault(require("../geom/Polygon"));
var LineString_1 = __importDefault(require("../geom/LineString"));
var LinearRing_1 = __importDefault(require("../geom/LinearRing"));
var MultiPoint_1 = __importDefault(require("../geom/MultiPoint"));
var MultiPolygon_1 = __importDefault(require("../geom/MultiPolygon"));
var GeometryType_1 = require("../geom/GeometryType");
var MultiLineString_1 = __importDefault(require("../geom/MultiLineString"));
var GeometryCollection_1 = __importDefault(require("../geom/GeometryCollection"));
var WKBUtils = /** @class */ (function () {
    function WKBUtils() {
    }
    WKBUtils.wkbToGeom = function (buff) {
        var reader = new ginkgoch_buffer_io_1.BufferReader(buff);
        var bigEndian = WKBUtils._readByteEndian(reader);
        var geomType = WKBUtils._readGeomType(reader, bigEndian);
        switch (geomType) {
            case GeometryType_1.GeometryType.Point:
                return WKBUtils._readPoint(reader, bigEndian);
            case GeometryType_1.GeometryType.LineString:
                return WKBUtils._readLine(reader, bigEndian);
            case GeometryType_1.GeometryType.Polygon:
                return WKBUtils._readPolygon(reader, bigEndian);
            case GeometryType_1.GeometryType.MultiPoint:
                return WKBUtils._readMultiPoint(reader, bigEndian);
            case GeometryType_1.GeometryType.MultiLineString:
                return WKBUtils._readMultiLine(reader, bigEndian);
            case GeometryType_1.GeometryType.MultiPolygon:
                return WKBUtils._readMultiPolygon(reader, bigEndian);
            case GeometryType_1.GeometryType.GeometryCollection:
                return WKBUtils._readGeomCollection(reader, bigEndian);
            default:
                throw new Error('Not supported wkb.');
        }
    };
    WKBUtils.geomToWKB = function (geom, bigEndian) {
        if (bigEndian === void 0) { bigEndian = false; }
        if (geom instanceof Point_1.default) {
            return WKBUtils._pointToWKB(geom, bigEndian);
        }
        else if (geom instanceof LineString_1.default) {
            return WKBUtils._lineToWKB(geom, bigEndian);
        }
        else if (geom instanceof Polygon_1.default) {
            return WKBUtils._polygonToWKB(geom, bigEndian);
        }
        else if (geom instanceof MultiPoint_1.default) {
            return WKBUtils._multiPointToWKB(geom, bigEndian);
        }
        else if (geom instanceof MultiLineString_1.default) {
            return WKBUtils._multiLineToWKB(geom, bigEndian);
        }
        else if (geom instanceof MultiPolygon_1.default) {
            return WKBUtils._multiPolygonToWKB(geom, bigEndian);
        }
        else if (geom instanceof GeometryCollection_1.default) {
            return WKBUtils._geomCollectionToWKB(geom, bigEndian);
        }
        else {
            throw new Error('Unknown geometry.');
        }
    };
    WKBUtils._geomCollectionToWKB = function (geom, bigEndian) {
        var buff = Buffer.alloc(WKBUtils._sizeOfGeomCollection(geom));
        var writer = new ginkgoch_buffer_io_1.BufferWriter(buff);
        WKBUtils._writeGeomCollection(writer, geom, bigEndian);
        return buff;
    };
    WKBUtils._sizeOfGeomCollection = function (geom) {
        return 1 + Constants_1.default.SIZE_GEOM_TYPE +
            Constants_1.default.SIZE_INT32 +
            lodash_1.default.sumBy(geom.children, function (g) { return WKBUtils._sizeOfGeom(g); });
    };
    WKBUtils._sizeOfGeom = function (g) {
        if (g instanceof Point_1.default) {
            return WKBUtils._sizeOfPoint();
        }
        else if (g instanceof LineString_1.default) {
            return WKBUtils._sizeOfLine(g);
        }
        else if (g instanceof Polygon_1.default) {
            return WKBUtils._sizeOfPolygon(g);
        }
        else if (g instanceof MultiPoint_1.default) {
            return WKBUtils._sizeOfMultiPoint(g);
        }
        else if (g instanceof MultiLineString_1.default) {
            return WKBUtils._sizeOfMultiLine(g);
        }
        else if (g instanceof MultiPolygon_1.default) {
            return WKBUtils._sizeOfMultiPolygon(g);
        }
        else if (g instanceof GeometryCollection_1.default) {
            return WKBUtils._sizeOfGeomCollection(g);
        }
        else {
            throw new Error('Unsupported geometry.');
        }
    };
    WKBUtils._writeGeomCollection = function (writer, geom, bigEndian) {
        WKBUtils._writeByteEndian(writer, bigEndian);
        WKBUtils._writeGeomType(writer, GeometryType_1.GeometryType.GeometryCollection, bigEndian);
        WKBUtils._writeInt32(writer, geom.children.length, bigEndian);
        geom.children.forEach(function (g) { return WKBUtils._writeGeom(writer, g, bigEndian); });
    };
    WKBUtils._writeGeom = function (writer, g, bigEndian) {
        if (g instanceof Point_1.default) {
            WKBUtils._writePoint(writer, g, bigEndian);
        }
        else if (g instanceof LineString_1.default) {
            WKBUtils._writeLine(writer, g, bigEndian);
        }
        else if (g instanceof Polygon_1.default) {
            WKBUtils._writePolygon(writer, g, bigEndian);
        }
        else if (g instanceof MultiPoint_1.default) {
            WKBUtils._writeMultiPoint(writer, g, bigEndian);
        }
        else if (g instanceof MultiLineString_1.default) {
            WKBUtils._writeMultiLine(writer, g, bigEndian);
        }
        else if (g instanceof MultiPolygon_1.default) {
            WKBUtils._writeMultiPolygon(writer, g, bigEndian);
        }
        else if (g instanceof GeometryCollection_1.default) {
            WKBUtils._writeGeomCollection(writer, g, bigEndian);
        }
        else {
            throw new Error('Unsupported geometry.');
        }
    };
    WKBUtils._readGeomCollection = function (reader, bigEndian) {
        var geomCollection = new GeometryCollection_1.default();
        var count = WKBUtils._readInt32(reader, bigEndian);
        for (var i = 0; i < count; i++) {
            var geom = WKBUtils._readGeom(reader);
            geomCollection.children.push(geom);
        }
        return geomCollection;
    };
    WKBUtils._readGeom = function (reader) {
        var bigEndian = WKBUtils._readByteEndian(reader);
        var geomType = WKBUtils._readGeomType(reader, bigEndian);
        switch (geomType) {
            case GeometryType_1.GeometryType.Point:
                return WKBUtils._readPoint(reader, bigEndian);
            case GeometryType_1.GeometryType.LineString:
                return WKBUtils._readLine(reader, bigEndian);
            case GeometryType_1.GeometryType.Polygon:
                return WKBUtils._readPolygon(reader, bigEndian);
            case GeometryType_1.GeometryType.MultiPoint:
                return WKBUtils._readMultiPoint(reader, bigEndian);
            case GeometryType_1.GeometryType.MultiLineString:
                return WKBUtils._readMultiLine(reader, bigEndian);
            case GeometryType_1.GeometryType.MultiPolygon:
                return WKBUtils._readMultiPolygon(reader, bigEndian);
            case GeometryType_1.GeometryType.GeometryCollection:
                return WKBUtils._readGeomCollection(reader, bigEndian);
            default:
                throw new Error('Unsupported geometry type.');
        }
    };
    WKBUtils._multiPolygonToWKB = function (geom, bigEndian) {
        var size = WKBUtils._sizeOfMultiPolygon(geom);
        var buff = Buffer.alloc(size);
        var writer = new ginkgoch_buffer_io_1.BufferWriter(buff);
        WKBUtils._writeMultiPolygon(writer, geom, bigEndian);
        return buff;
    };
    WKBUtils._sizeOfMultiPolygon = function (geom) {
        return 1 + Constants_1.default.SIZE_GEOM_TYPE +
            Constants_1.default.SIZE_INT32 +
            lodash_1.default.sumBy(geom.children, function (p) { return WKBUtils._sizeOfPolygon(p); });
    };
    WKBUtils._writeMultiPolygon = function (writer, geom, bigEndian) {
        WKBUtils._writeByteEndian(writer, bigEndian);
        WKBUtils._writeGeomType(writer, GeometryType_1.GeometryType.MultiPolygon, bigEndian);
        WKBUtils._writeInt32(writer, geom.children.length, bigEndian);
        geom.children.forEach(function (p) {
            WKBUtils._writePolygon(writer, p, bigEndian);
        });
    };
    WKBUtils._readMultiPolygon = function (reader, bigEndian) {
        var count = WKBUtils._readInt32(reader, bigEndian);
        var multiPolygon = new MultiPolygon_1.default();
        for (var i = 0; i < count; i++) {
            var currentBigEndian = WKBUtils._readByteEndian(reader);
            var currentGeomType = WKBUtils._readGeomType(reader, currentBigEndian);
            assert_1.default(currentGeomType === GeometryType_1.GeometryType.Polygon, 'Non-Polygon in MultiPolygon.');
            var polygon = WKBUtils._readPolygon(reader, bigEndian);
            multiPolygon.children.push(polygon);
        }
        return multiPolygon;
    };
    WKBUtils._multiLineToWKB = function (geom, bigEndian) {
        var size = WKBUtils._sizeOfMultiLine(geom);
        var buff = Buffer.alloc(size);
        var writer = new ginkgoch_buffer_io_1.BufferWriter(buff);
        WKBUtils._writeMultiLine(writer, geom, bigEndian);
        return buff;
    };
    WKBUtils._sizeOfMultiLine = function (geom) {
        return 1 + Constants_1.default.SIZE_GEOM_TYPE +
            Constants_1.default.SIZE_INT32 +
            lodash_1.default.sumBy(geom.children, function (l) { return WKBUtils._sizeOfLine(l); });
    };
    WKBUtils._writeMultiLine = function (writer, geom, bigEndian) {
        WKBUtils._writeByteEndian(writer, bigEndian);
        WKBUtils._writeGeomType(writer, GeometryType_1.GeometryType.MultiLineString, bigEndian);
        WKBUtils._writeInt32(writer, geom.children.length, bigEndian);
        geom.children.forEach(function (l) {
            WKBUtils._writeByteEndian(writer, bigEndian);
            WKBUtils._writeGeomType(writer, GeometryType_1.GeometryType.LineString, bigEndian);
            WKBUtils._writeCoordinates(writer, l._coordinates, bigEndian);
        });
    };
    WKBUtils._readMultiLine = function (reader, bigEndian) {
        var multiLine = new MultiLineString_1.default();
        var count = WKBUtils._readInt32(reader, bigEndian);
        for (var i = 0; i < count; i++) {
            var currentBigEndian = WKBUtils._readByteEndian(reader);
            var currentGeomType = WKBUtils._readGeomType(reader, currentBigEndian);
            assert_1.default(currentGeomType === GeometryType_1.GeometryType.LineString, 'Non-LineString in MultiLineString.');
            var currentCoordinates = WKBUtils._readCoordinates(reader, currentBigEndian);
            multiLine.children.push(new LineString_1.default(currentCoordinates));
        }
        return multiLine;
    };
    WKBUtils._multiPointToWKB = function (geom, bigEndian) {
        var size = WKBUtils._sizeOfMultiPoint(geom);
        var buff = Buffer.alloc(size);
        var writer = new ginkgoch_buffer_io_1.BufferWriter(buff);
        WKBUtils._writeMultiPoint(writer, geom, bigEndian);
        return buff;
    };
    WKBUtils._sizeOfMultiPoint = function (geom) {
        return 1 + Constants_1.default.SIZE_GEOM_TYPE + WKBUtils._sizeOfPoint() * geom.children.length;
    };
    WKBUtils._writeMultiPoint = function (writer, geom, bigEndian) {
        WKBUtils._writeByteEndian(writer, bigEndian);
        WKBUtils._writeGeomType(writer, GeometryType_1.GeometryType.MultiPoint, bigEndian);
        WKBUtils._writeInt32(writer, geom.children.length, bigEndian);
        geom.children.forEach(function (p) {
            WKBUtils._writePoint(writer, p, bigEndian);
        });
    };
    WKBUtils._readMultiPoint = function (reader, bigEndian) {
        var count = WKBUtils._readInt32(reader, bigEndian);
        var multiPoint = new MultiPoint_1.default();
        for (var i = 0; i < count; i++) {
            var currentBigEndian = WKBUtils._readByteEndian(reader);
            var currentGeomType = WKBUtils._readGeomType(reader, currentBigEndian);
            assert_1.default(currentGeomType === GeometryType_1.GeometryType.Point, 'Non-Point in MultiPoint.');
            var currentCoordinate = WKBUtils._readCoordinate(reader, currentBigEndian);
            multiPoint.children.push(new Point_1.default(currentCoordinate.x, currentCoordinate.y));
        }
        return multiPoint;
    };
    WKBUtils._polygonToWKB = function (geom, bigEndian) {
        if (bigEndian === void 0) { bigEndian = false; }
        var buff = Buffer.alloc(WKBUtils._sizeOfPolygon(geom));
        var writer = new ginkgoch_buffer_io_1.BufferWriter(buff);
        WKBUtils._writePolygon(writer, geom, bigEndian);
        return buff;
    };
    WKBUtils._sizeOfPolygon = function (geom) {
        var size = 1 + Constants_1.default.SIZE_GEOM_TYPE +
            Constants_1.default.SIZE_INT32 + // ring count
            Constants_1.default.SIZE_INT32 + // exterior ring coordinates count
            geom.externalRing._coordinates.length * Constants_1.default.SIZE_POINT + // exterior ring coordinates
            Constants_1.default.SIZE_INT32 * geom.internalRings.length + // all interior ring coordinates count
            lodash_1.default.sumBy(geom.internalRings, function (r) { return r._coordinates.length * Constants_1.default.SIZE_POINT; }); // all interior ring coordinates
        return size;
    };
    WKBUtils._writePolygon = function (writer, geom, bigEndian) {
        WKBUtils._writeByteEndian(writer, bigEndian);
        WKBUtils._writeGeomType(writer, GeometryType_1.GeometryType.Polygon, bigEndian);
        WKBUtils._writeInt32(writer, geom.internalRings.length + 1, bigEndian);
        WKBUtils._writeCoordinates(writer, geom.externalRing._coordinates, bigEndian);
        geom.internalRings.forEach(function (r) {
            WKBUtils._writeCoordinates(writer, r._coordinates, bigEndian);
        });
    };
    WKBUtils._readPolygon = function (reader, bigEndian) {
        var ringCount = WKBUtils._readInt32(reader, bigEndian);
        var coordinates = WKBUtils._readCoordinates(reader, bigEndian);
        var polygon = new Polygon_1.default(new LinearRing_1.default(coordinates));
        for (var i = 1; i < ringCount; i++) {
            coordinates = WKBUtils._readCoordinates(reader, bigEndian);
            polygon.internalRings.push(new LinearRing_1.default(coordinates));
        }
        return polygon;
    };
    WKBUtils._pointToWKB = function (point, bigEndian) {
        if (bigEndian === void 0) { bigEndian = false; }
        var buff = Buffer.alloc(WKBUtils._sizeOfPoint());
        var writer = new ginkgoch_buffer_io_1.BufferWriter(buff);
        WKBUtils._writePoint(writer, point, bigEndian);
        return buff;
    };
    WKBUtils._sizeOfPoint = function () {
        var size = 1 + Constants_1.default.SIZE_GEOM_TYPE + Constants_1.default.SIZE_POINT;
        return size;
    };
    WKBUtils._writePoint = function (writer, geom, bigEndian) {
        WKBUtils._writeByteEndian(writer, bigEndian);
        WKBUtils._writeGeomType(writer, GeometryType_1.GeometryType.Point, bigEndian);
        WKBUtils._writeCoordinate(writer, geom, bigEndian);
    };
    WKBUtils._readPoint = function (reader, bigEndian) {
        var x = WKBUtils._readDouble(reader, bigEndian);
        var y = WKBUtils._readDouble(reader, bigEndian);
        return new Point_1.default(x, y);
    };
    WKBUtils._lineToWKB = function (line, bigEndian) {
        if (bigEndian === void 0) { bigEndian = false; }
        var buff = Buffer.alloc(WKBUtils._sizeOfLine(line));
        var writer = new ginkgoch_buffer_io_1.BufferWriter(buff);
        WKBUtils._writeLine(writer, line, bigEndian);
        return buff;
    };
    WKBUtils._sizeOfLine = function (geom) {
        var size = 1 + Constants_1.default.SIZE_GEOM_TYPE +
            Constants_1.default.SIZE_INT32 +
            Constants_1.default.SIZE_POINT * geom._coordinates.length;
        return size;
    };
    WKBUtils._writeLine = function (writer, geom, bigEndian) {
        WKBUtils._writeByteEndian(writer, bigEndian);
        WKBUtils._writeGeomType(writer, GeometryType_1.GeometryType.LineString, bigEndian);
        WKBUtils._writeCoordinates(writer, geom._coordinates, bigEndian);
    };
    WKBUtils._readLine = function (reader, bigEndian) {
        var count = WKBUtils._readInt32(reader, bigEndian);
        var line = new LineString_1.default();
        for (var i = 0; i < count; i++) {
            line._coordinates.push(WKBUtils._readCoordinate(reader, bigEndian));
        }
        return line;
    };
    WKBUtils._writeCoordinates = function (writer, coordinates, bigEndian) {
        WKBUtils._writeInt32(writer, coordinates.length, bigEndian);
        coordinates.forEach(function (c) {
            WKBUtils._writeCoordinate(writer, c, bigEndian);
        });
    };
    WKBUtils._readCoordinates = function (reader, bigEndian) {
        var count = WKBUtils._readInt32(reader, bigEndian);
        var coordinates = [];
        for (var i = 0; i < count; i++) {
            var coordinate = WKBUtils._readCoordinate(reader, bigEndian);
            coordinates.push(coordinate);
        }
        return coordinates;
    };
    WKBUtils._writeByteEndian = function (writer, bigEndian) {
        var be = bigEndian ? 0 : 1;
        writer.writeInt8(be);
    };
    WKBUtils._readByteEndian = function (reader) {
        return reader.nextInt8() === 0;
    };
    WKBUtils._writeInt32 = function (writer, n, bigEndian) {
        if (bigEndian) {
            writer.writeInt32BE(n);
        }
        else {
            writer.writeInt32LE(n);
        }
    };
    WKBUtils._readInt32 = function (reader, bigEndian) {
        if (bigEndian) {
            return reader.nextInt32BE();
        }
        else {
            return reader.nextInt32LE();
        }
    };
    WKBUtils._writeDouble = function (writer, n, bigEndian) {
        if (bigEndian) {
            writer.writeDoubleBE(n);
        }
        else {
            writer.writeDoubleLE(n);
        }
    };
    WKBUtils._readDouble = function (reader, bigEndian) {
        if (bigEndian) {
            return reader.nextDoubleBE();
        }
        else {
            return reader.nextDoubleLE();
        }
    };
    WKBUtils._writeCoordinate = function (writer, coordinate, bigEndian) {
        if (bigEndian) {
            writer.writeDoubleBE(coordinate.x);
            writer.writeDoubleBE(coordinate.y);
        }
        else {
            writer.writeDoubleLE(coordinate.x);
            writer.writeDoubleLE(coordinate.y);
        }
    };
    WKBUtils._readCoordinate = function (reader, bigEndian) {
        if (bigEndian) {
            var x = reader.nextDoubleBE();
            var y = reader.nextDoubleBE();
            return { x: x, y: y };
        }
        else {
            var x = reader.nextDoubleLE();
            var y = reader.nextDoubleLE();
            return { x: x, y: y };
        }
    };
    WKBUtils._writeGeomType = function (writer, geomType, bigEndian) {
        var geomNum = this._geomTypeToGeomNum(geomType);
        if (bigEndian) {
            writer.writeInt32BE(geomNum);
        }
        else {
            writer.writeInt32LE(geomNum);
        }
    };
    WKBUtils._readGeomType = function (reader, bigEndian) {
        var geomNum;
        if (bigEndian) {
            geomNum = reader.nextInt32BE();
        }
        else {
            geomNum = reader.nextInt32LE();
        }
        return this._geomNumToGeomType(geomNum);
    };
    WKBUtils._geomTypeToGeomNum = function (geomType) {
        switch (geomType) {
            case GeometryType_1.GeometryType.Point:
                return 1;
            case GeometryType_1.GeometryType.LineString:
                return 2;
            case GeometryType_1.GeometryType.Polygon:
                return 3;
            case GeometryType_1.GeometryType.MultiPoint:
                return 4;
            case GeometryType_1.GeometryType.MultiLineString:
                return 5;
            case GeometryType_1.GeometryType.MultiPolygon:
                return 6;
            case GeometryType_1.GeometryType.GeometryCollection:
                return 7;
            case GeometryType_1.GeometryType.Unknown:
            default:
                return 0;
        }
    };
    WKBUtils._geomNumToGeomType = function (num) {
        switch (num) {
            case 1:
                return GeometryType_1.GeometryType.Point;
            case 2:
                return GeometryType_1.GeometryType.LineString;
            case 3:
                return GeometryType_1.GeometryType.Polygon;
            case 4:
                return GeometryType_1.GeometryType.MultiPoint;
            case 5:
                return GeometryType_1.GeometryType.MultiLineString;
            case 6:
                return GeometryType_1.GeometryType.MultiPolygon;
            case 7:
                return GeometryType_1.GeometryType.GeometryCollection;
            case 0:
            default:
                return GeometryType_1.GeometryType.Unknown;
        }
    };
    return WKBUtils;
}());
exports.default = WKBUtils;
